import React, { useState, useRef } from 'react';
import { ControlButton } from '../ControlButton/index.ts';
import IconCheckMark from '@static/images/icon_check.svg';
import IconShare from '@static/images/icon_share.svg';
import { T } from '@colonist/ui';
export const ReplayControlsShareButton = ({ onShare, className })=>{
    const [shareTooltip, setShareTooltip] = useState('strings:game.tooltips.replay.shareReplay');
    const [shareIcon, setShareIcon] = useState(IconShare);
    const timeoutRef = useRef(null);
    const handleShare = ()=>{
        if (timeoutRef.current) return;
        onShare === null || onShare === void 0 ? void 0 : onShare();
        setShareTooltip('strings:game.tooltips.replay.copiedLink');
        setShareIcon(IconCheckMark);
        timeoutRef.current = setTimeout(()=>{
            setShareTooltip('strings:game.tooltips.replay.shareReplay');
            setShareIcon(IconShare);
            timeoutRef.current = null;
        }, 1500);
    };
    return /*#__PURE__*/ React.createElement(ControlButton, {
        icon: shareIcon,
        alt: "strings:imgAlts.Share",
        className: className,
        onClick: handleShare,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: shareTooltip
        })
    });
};
